import { __rest } from "tslib";
import styled from '@emotion/styled';
import React from 'react';
const Wrapper = styled.div `
	position: relative;
	width: ${({ width }) => width};
	height: ${({ height }) => height};
	min-height: ${({ minHeight }) => minHeight !== null && minHeight !== void 0 ? minHeight : 'none'};
`;
const Video = styled.video `
	object-fit: cover;
	object-position: center;
	width: 100%;
	height: 100%;
	max-width: 100vw;
`;
const Overlay = styled.div `
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	width: 100%;
	height: 100%;
`;
const getTypeFromSrc = (src) => {
    var _a, _b, _c;
    const ext = (_c = (_b = (_a = src === null || src === void 0 ? void 0 : src.split('.')) === null || _a === void 0 ? void 0 : _a.slice(-1)) === null || _b === void 0 ? void 0 : _b[0]) !== null && _c !== void 0 ? _c : 'mp4';
    return `video/${ext}`;
};
export const VideoHero = (_a) => {
    var { children, sources, width = '100%', height = '50vh', style, className } = _a, videoProps = __rest(_a, ["children", "sources", "width", "height", "style", "className"]);
    const { autoPlay = true, muted = true, loop = true, controls = false, } = videoProps;
    return (React.createElement(Wrapper, { width: width, height: height, className: className, style: style },
        React.createElement(Video, Object.assign({ autoPlay: autoPlay, muted: muted, loop: loop, controls: controls }, videoProps), sources === null || sources === void 0 ? void 0 : sources.map((src) => (React.createElement("source", { key: getTypeFromSrc(src), type: getTypeFromSrc(src), src: src })))),
        children && React.createElement(Overlay, null, children)));
};
//# sourceMappingURL=VideoHero.js.map